import { styled } from "@mui/material";
import React from "react";

interface ValueProgressIndicatorProps {
    value: number;
    showSign?: boolean;
    formatFunction?: (value: number) => string;
}
const StyledSpan = styled('span')<{ isPositive: boolean }>(({ isPositive, theme }) => ({
    color: isPositive ? theme.palette.success.main : theme.palette.error.main,
    fontWeight: 800,
}));

const ValueProgressIndicator = ({ value, showSign = true, formatFunction}: ValueProgressIndicatorProps) => {
    const isPositiveValue = value >= 0;

    return (
        <StyledSpan isPositive={isPositiveValue}>
            {showSign && isPositiveValue && '+'}
            {formatFunction ? formatFunction(value) : value}
        </StyledSpan>
    );
};

export default ValueProgressIndicator;
